// extracted by mini-css-extract-plugin
export default {"portalLogo":"ek0k_JbCwmLeibbShI84"};